import Util from '../../../libs/util';
const { createConsumer } = require('@rails/actioncable');
console.log('websocket_host', Util.websocket_host)
export default createConsumer(`${Util.websocket_host}/cable`)
